export enum EmailTemplateType {
    none = 0,
    newTicketToAdmin = 1,
    newTicketToCreator = 2,
    newReplyToClient = 4,
    newReplyToStaff = 8,
    assignedToVendor = 16,
    assignedToStaff = 32,
    mentionedInNote = 64,
    userRegistration = 128,
    resetPassword = 256,
    userAssignedToCategory = 512, // not used
    userAccountDeletion = 1024, // not used
    newCommunity = 2048, // not used
    brokenTokensNotification = 4096,
    gdprPortalForwardingAddressConfirmation = 8192,
    gdprRequestUserAddressConfirmation = 16384,
    gdprRequestResultFilePassword = 32768,
    gdprRequestResultFile = 65536,
    attentionEmail = 131072,
    detectingUnknownEmail = 262144,
    emailVerification = 524288,
    userAssignedToTicket = 1048576,
    newInternalTicketToCreator = 2097152,
    newReplyWithCustomerPortalLink = 4194304,
    newInternalTicketToCreatorWithCustomerPortalLink = 8388608,
    toCustomersWhenSendingASurvey = 16777216,
    ticketMovedToUserCategory = 33554432,
}
